import React from "react";
import UndoButton from "./undo-button";
import RedoButton from "./redo-button";
import {
    HistoryOptions,
    RichTextTool,
} from "@common/components/forms/rich-text-form-field/tools/tools-types.enum";

interface HistoryGroupProps {
    onUndo: () => void;
    onRedo: () => void;
    hiddenOptions?: RichTextTool[];
}

const HistoryGroup: React.FC<HistoryGroupProps> = (props) => {
    return (
        <>
            {!props.hiddenOptions?.includes(HistoryOptions.UNDO) && (
                <UndoButton onUndo={props.onUndo}/>
            )}
            {!props.hiddenOptions?.includes(HistoryOptions.REDO) && (
                <RedoButton onRedo={props.onRedo}/>
            )}
        </>
    );
};

export default HistoryGroup;
